import BigNumber from "bignumber.js";
import type { Service } from "../../types";

export const formatPortfolioAmountWithoutFees = (service: Service): string => {
    const totals = new Map<string, BigNumber | null>();

    for (const invoice of service.transferInvoices ?? []) {
        const currency = invoice.currency || service.portfolioOpeningRequest?.currency || "";
        const amount = invoice.initialAmount == null ? null : new BigNumber(invoice.initialAmount);

        // A missing initial amount makes the currency total unknown; never use the fee-inclusive amount.
        if (!amount?.isFinite() || totals.get(currency) === null) {
            totals.set(currency, null);
        } else {
            totals.set(currency, (totals.get(currency) ?? new BigNumber(0)).plus(amount));
        }
    }

    return Array.from(totals.entries())
        .sort(([a], [b]) => a.localeCompare(b))
        .map(([currency, amount]) => `${amount === null ? "Not set" : amount.toFormat()}${currency ? ` ${currency}` : ""}`)
        .join(" · ") || "—";
};
